import { Mode } from "../types/Types";

interface ModeButtonProps {
  id: Mode;
  mode: string;
  title: string;
  setMode: (mode: Mode) => void;
}

const ModeButton: React.FC<ModeButtonProps> = ({
  id,
  mode,
  title,
  setMode
}) => {
  const active = mode === id;
  return ( 
    <div
      id={id} 
      onClick={() => setMode(id)}
      className={`${active ? 'underline font-extrabold' : 'font-bold'} cursor-pointer`}
    >
      {title}
    </div>
   );
}
 
export default ModeButton;
